import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'localization/LocalizedLeaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import styles from '../AdminPanelPage.module.scss'

const TopBasesMapView = ({ branches = [], topBases = [] }) => {
  useInterfaceLanguage();
  // Filter branches that belong to TOP BASES ONLY and have valid geo coordinates
  const branchesWithGeo = branches.filter(br => {
    if (!br.top_base || !br.geo) return false
    const coords = br.geo.split(',').map(s => parseFloat(s.trim()))
    return coords.length === 2 && !coords.some(isNaN)
  })

  if (branchesWithGeo.length === 0) {
    return (
      <div className={styles.panel} style={{ marginTop: 20 }}>
        <div className={styles.panelHeader}>
          <div className={styles.panelTitle}>{tr("Карта филиалов ТОП-баз")}</div>
        </div>
        <div className={styles.panelBody}>
          <div style={{ padding: 20, textAlign: 'center', color: "var(--theme-text-muted, #999)" }}>{tr("Нет филиалов ТОП-баз с геолокацией для отображения на карте")}</div>
        </div>
      </div>
    )
  }

  // Calculate center of all points
  const allCoords = branchesWithGeo.map(br => {
    const coords = br.geo.split(',').map(s => parseFloat(s.trim()))
    return coords
  })
  const centerLat = allCoords.reduce((sum, c) => sum + c[0], 0) / allCoords.length
  const centerLng = allCoords.reduce((sum, c) => sum + c[1], 0) / allCoords.length

  // Границы Кыргызстана
  const kyrgyzstanBounds = [
    [39.172, 69.276], // Southwest
    [43.238, 80.283]  // Northeast
  ]

  // Custom marker icon
  const markerIcon = new L.Icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  })

  const getBaseName = (br) => {
    const base = topBases.find(tb => tb.id === br.top_base)
    return base ? base.name : tr("ТОП-База")
  }

  return (
    <div className={styles.panel} style={{ marginTop: 20 }}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitle}>{tr("Карта филиалов ТОП-баз (")}{tr(branchesWithGeo.length)})</div>
      </div>
      <div className={styles.panelBody}>
        <div style={{ height: 500, width: '100%' }}>
          <MapContainer center={[centerLat, centerLng]} zoom={10} minZoom={7} maxBounds={kyrgyzstanBounds} maxBoundsViscosity={1.0} style={{ height: '100%', width: '100%' }} attributionControl={false} zoomControl={false}>
            <TileLayer 
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              attribution="&copy; Esri"
              maxZoom={19}
            />
            <TileLayer 
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution=""
              maxZoom={19}
              opacity={0.65}
            />
            {branchesWithGeo.map(br => {
              const coords = br.geo.split(',').map(s => parseFloat(s.trim()))
              const baseName = getBaseName(br)
              return (
                <Marker key={br.id} position={coords} icon={markerIcon}>
                  <Popup>
                    <div>
                      <strong>{tr(br.address || tr("Адрес не указан"))} - {tr(baseName)}</strong>
                      <br />{tr("Филиал: ")}{tr(br.name)}
                      <br />{tr("Координаты: ")}{tr(br.geo)}
                    </div>
                  </Popup>
                </Marker>
              )
            })}
          </MapContainer>
        </div>
      </div>
    </div>
  )
}

export default TopBasesMapView
